import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import DocumentTitle from 'react-document-title';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { pipe, map, flatten, prop, path} from 'ramda';
import views from '@/views';
import routesConfig from './config';

const router = props => {
  const generateRoute = ( routes=[], title='TDMP' ) => {
    return map( each =>
      each.component ? (
        <Route
          key={ each.path }
          exact
          path={ each.path }
          render={ props => {
            const reg = /\?\S*/;
            const queryParams = window.location.search.match(reg);  // 匹配路由参数
            const { params } = props.match;
            Object.keys(params).forEach( key => { // 去除?参数
              params[key] = params[key] && params[key].replace(reg, '');
            });
            props.match.params = { ...params };
            const merge = { ...props, query: queryParams ? queryString.parse(queryParams[0]) : {} };
            const View = views[each.component];
            const wrapperView = (
              <DocumentTitle title={ each.title ?? title }>
                <View { ...merge } />
              </DocumentTitle>
            );
            return (requireLogin(wrapperView, each.auth));
          }}
        />
      )
      : generateRoute(each.routes, title), routes);
  };

  const requireLogin =  ( component, permission ) => {
    const { user } = props;
    const isLogin = user.account || false;
    if(!isLogin) {
      return (<Redirect to={'/login'} />);
    }
    return (permission ? requirePermission(component, permission) : component);
  };

  const requirePermission =  ( component, permission ) => {
    const permissions = path(['user', 'permission'], props);
    if (!permissions || !checkPermission(permission, permissions)) {
      return <Redirect to='/autherror' />;
    }
    return component;
  };

  const checkPermission = ( requirePers, userPers ) => {
    const isAdmin = path(['user', 'isAdmin'], this.props);
    if (isAdmin) return true;
    if (typeof userPers === 'undefined') return false;
    if (Array.isArray(requirePers)) {
      return requirePers.every( each => userPers.includes(each));
    } else if (requirePers instanceof RegExp) {
      return userPers.some( each => requirePers.test(each));
    }
    return userPers.includes(requirePers);
  };

  return (
    <Switch>
      { pipe(map( each => {
        const routes = each.routes;
        return generateRoute(routes, each.title);
        }), flatten)(routesConfig)
      }
      <Route render={ () => <Redirect to='/404' /> } />
    </Switch>
  );

};

const mapStateToProps = ({ user }) => {
  return { user };
};

export default connect(
  mapStateToProps
)(router);
